import { Identifiable, Status } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeTaskStatus(httpClient: HttpClient) {
  return (status: Identifiable<Status>, nextStatus: Identifiable<Status>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/statuses/${status.uuid}/delete`,
      method: HttpMethods.DELETE,
      data: { sourceStatus: status.uuid, destinationStatus: nextStatus.uuid },
    });
}

export { removeTaskStatus };
